import { PREMIUM_PAGE, SUBSCRIPTION_STATUS_DETAILS } from "../../../../../Constants/routesConstant";
import { redirectToDashy } from "../../../../../Utils/common";
import { TRACKING_EVENTS } from "../../../../../Utils/GAEvents/gaEventsConstants";
import { useAppConstants } from "../../../../../Hooks/useAppConstants";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ArrowWhiteSvg() {
  return (
    <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.762 4.62257L9.8833 7.74211C9.72464 7.91404 9.51671 8 9.30876 8C9.10081 8 8.89289 7.91404 8.73422 7.74211C8.41694 7.39826 8.41694 6.84079 8.73422 6.49694L10.2259 4.88046H0.8125C0.363771 4.88046 0 4.48626 0 4C0 3.51373 0.363771 3.11953 0.8125 3.11953H10.2259L8.73422 1.50306C8.41694 1.15921 8.41694 0.601735 8.73422 0.257887C9.05155 -0.0859622 9.56597 -0.0859622 9.8833 0.257887L12.762 3.37743C13.0793 3.72125 13.0793 4.27875 12.762 4.62257Z"
        fill="white"
      />
    </svg>
  );
}

const DashboardRedirectBanner = ({ sendPostPurchaseDataToGAEvent }) => {
  const {
    workspace: { sell_titan_email_free_with_domain, free_titan_licenses_count },
  } = useAppConstants();

  if (!sell_titan_email_free_with_domain) {
    return null;
  }

  const SLIDER_DATA = [
    {
      label: `Now manage your domains, e-mail accounts, create a stunning website & marketing features all at one place.`,
      ctaText: "Go to my dashboard",
      redirectRoute: '/orders',
      visible: true,
    },
    {
      label: `You have ${free_titan_licenses_count} new e-mail account${free_titan_licenses_count > 1 ? "s" : ""}, Activate it from your digital showroom dashboard.`,
      ctaText: "Activate Email",
      redirectRoute: SUBSCRIPTION_STATUS_DETAILS,
      visible: sell_titan_email_free_with_domain,
    },
  ];

  const handleGoToDashboardClick = (route) => {
    sendPostPurchaseDataToGAEvent(TRACKING_EVENTS.postPurchaseGoToDashboard);
    redirectToDashy(route);
  };

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div
      className="tw-flex tw-items-center tw-justify-center tw-font-jakarta"
      style={{
        background: "linear-gradient(90deg, #4138A8 0%, #716F8D 100%)",
      }}
    >
      <Slider {...settings}>
        {SLIDER_DATA.map((data) => {
          if (!data.visible) {
            return null;
          }
          return (
            <div>
              <div className="tw-flex tw-items-center tw-justify-center tw-font-jakarta tw-text-white">
                <div className="tw-flex tw-gap-1.5">
                  <span className="tw-text-[12px] tw-text-base tw-font-normal">{data.label}</span>
                  <div
                    className="banner_redirect_cta tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-1.5 "
                    onClick={() => handleGoToDashboardClick(data.redirectRoute)}
                  >
                    <span className="tw-inline-block tw-pb-[2px] tw-text-[13px] tw-text-base tw-font-semibold">
                      {data.ctaText}
                    </span>
                    <span style={{ marginTop: -4 }}>
                      <ArrowWhiteSvg />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};
export default DashboardRedirectBanner;
